<template>
    <a
        :class="['button', { large: large, secondary: secondary }, 'text-center']"
    >
        <slot />
    </a>
</template>

<script>
export default {
    name: 'BaseButtonLink',
    props: {
        large: {
            type: Boolean,
            default() {
                return false;
            }
        },
        secondary: {
            type: Boolean,
            default() {
                return false;
            }
        }
    }
};
</script>
